module.exports = __webpack_public_path__ + "img/banner_mob_brick.428dfd5b.png";